import cdnApi from './api/cdnApi';

export const ORGANIZATION_LIST = 'ORGANIZATION/LIST';


const initialState = {
	organizations: [],
}

export default (state = initialState, action) => {
	switch (action.type) {
		case ORGANIZATION_LIST:
			return {
				...state,
				organizations: action.payload
			};
		default:
			return state;
	}
};

export const organizationList = () => {
	return dispatch => {
		return cdnApi.get(`/organization`).then(data => {
			data.sort(function (a, b) {
				var nameA = a.name.toUpperCase();
				var nameB = b.name.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});
			dispatch({
				type: ORGANIZATION_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const organizationUpdate = (payload, id) => {
	return dispatch => {
		return cdnApi.patch(`/organization/`+id, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const organizationCreate = (payload) => {
	return dispatch => {
		return cdnApi.post(`/organization`, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
